import styled, { css } from 'styled-components';
import { CircleDismissButton } from "../DismissingCard/CircleDismissButton";

export const Container = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Container", componentId: "sc-9lhm3b-0" })(["width:100%;display:flex;border:none;border-radius:8px;max-width:", ";padding:", ";background-color:", ";"],




({ isFullWidth }) => isFullWidth ? 'unset' : '448px',
(props) => props.theme.spacers.M,
(props) => {var _props$backgroundColo;return (_props$backgroundColo = props.backgroundColor) !== null && _props$backgroundColo !== void 0 ? _props$backgroundColo : 'rgba(255, 199, 0, 0.1)';});


export const IconWrap = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__IconWrap", componentId: "sc-9lhm3b-1" })(["flex-shrink:0;margin-right:", ";height:20px;"],

(props) => props.theme.spacers.M);



export const Text = /*#__PURE__*/styled.p.withConfig({ displayName: "styles__Text", componentId: "sc-9lhm3b-2" })(["color:", ";", ";align-self:center;"],
(props) => {var _props$color;return (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : props.theme.colors['Level 5'];},
(props) => css(props.theme.typography.TinyParagraph));



export const DismissibleHintContainer = /*#__PURE__*/styled(Container).withConfig({ displayName: "styles__DismissibleHintContainer", componentId: "sc-9lhm3b-3" })(["display:block;"]);



export const DismissibleHintContent = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__DismissibleHintContent", componentId: "sc-9lhm3b-4" })(["display:flex;flex-direction:row;margin-right:22px;"]);





export const DismissButton = /*#__PURE__*/styled(CircleDismissButton).withConfig({ displayName: "styles__DismissButton", componentId: "sc-9lhm3b-5" })(["background-color:transparent;width:20px;height:20px;"]);